import React, { useState, useEffect, useRef, useCallback } from "react";
import IleyaSavingsDataService from "../services/IleyaSavingsService";
import { Link, useParams, useNavigate } from 'react-router-dom';
import TransactionTable from "../../components/TransactionTable";

const IleyaSavingsList = (props) => {
  const [ileya, setIleya] = useState([]);
  const ileyaRef = useRef();
  ileyaRef.current = ileya;

  let { owner } = useParams();

  const retrieveIleya = useCallback((ownerParam) => {
    const target = ownerParam ?? owner;
    IleyaSavingsDataService.getAll(target)
      .then((response) => {
        const payload = response?.data ?? response;
        const rows = payload?.data ?? payload?.ileya ?? payload;
        setIleya(Array.isArray(rows) ? rows : (rows ? [rows] : []));
      })
      .catch((e) => {
        console.error("IleyaSavingsList.retrieveIleya error:", e?.response?.status, e?.response?.data || e?.message || e);
        setIleya([]);
      });
  }, [owner]);

  const navigate = useNavigate();
  useEffect(() => {
    retrieveIleya();
  }, [retrieveIleya]);

  const deleteIleya = useCallback((rowIndex) => {
    const id = ileyaRef.current[rowIndex].id || ileyaRef.current[rowIndex]._id;
    IleyaSavingsDataService.remove(id)
      .then(() => {
        if (props?.history?.push) props.history.push("dashboard/ileyasavings");
        const newRows = [...ileyaRef.current];
        newRows.splice(rowIndex, 1);
        setIleya(newRows);
      })
      .catch((e) => {
        console.error("deleteIleya error:", e?.response?.status || e?.message || e);
      });
  }, [props.history]);

  const handleView = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/ileyasavings/${id}`);
  }, [props.history]);

  const handleEdit = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/ileyasavings/edit/${id}`);
  }, [props.history]);

  const handleDeleteRow = useCallback((row) => {
    const idx = ileyaRef.current.findIndex(item => (item.id || item._id) === (row.id || row._id));
    if (idx >= 0) deleteIleya(idx);
  }, [deleteIleya]);

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <TransactionTable
          transactions={ileya}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteRow}
          initialPageSize={10}
          showBack={true}
          onBack={() => navigate(-1)}
        />
      </div>

      <div className="col-md-8">
        <Link to={`/dashboard/ileyasavings/add/${owner || ""}`}>
           <button className="btn btn-sm btn-danger">Add Ileya Savings Transaction</button>
        </Link>
      </div>
    </div>
  );
};

export default IleyaSavingsList;
